module.exports = new __parcel__URL__("whatsapp.f9e02255.svg").toString();